import React from 'react';
import {Helmet} from 'react-helmet';
import _ from 'lodash';

import {safePrefix} from '../utils';
import Header from './Header';
import Footer from './Footer';

export default class Body extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>{_.get(this.props, 'pageContext.frontmatter.title') && _.get(this.props, 'pageContext.frontmatter.title') + ' - '}{_.get(this.props, 'pageContext.site.siteMetadata.title')}</title>
                    <meta charSet="utf-8" />
                    <link rel="stylesheet" href={safePrefix('assets/css/main.css')} />
                    <meta name="viewport" content="width=device-width, initialScale=1, userScalable=no" />
                    <noscript>{`<link rel="stylesheet" href=${safePrefix('assets/css/noscript.css')} />`}</noscript>
                    <body className={((_.get(this.props, 'pageContext.frontmatter.template') === _.get(this.props, 'pageContext.site.siteMetadata.landing_template')) ? 'landing ' : '')} />
                     {/* Facebook card */}
                    <meta property="og:type" content="website"></meta>
                    <meta property="og:title" content="Must Have VSCode Extensions"></meta>
                    <meta name="description" content="Jack of all Admins' list of must have VSCode extensions."></meta>
                    <meta property="og:url" content="https://vscode.jackofalladmins.com/"></meta>
                    <meta property="og:image" content="https://vscode.jackofalladmins.com/images/logo_horiz_ogimage.jpg"/>
                     {/* Twitter card */}
                    <meta property="twitter:image" content="https://vscode.jackofalladmins.com/images/logo_vertical_ogimage.jpg"></meta>
                    <meta name="twitter:site" content="@MStewGT"></meta>
                    <meta name="twitter:title" content="Must Have VSCode Extensions"></meta>
                    <meta name="twitter:description" content="Jack of all Admins' list of must have VSCode extensions."></meta>
                    <meta name="twitter:url" content="https://vscode.jackofalladmins.com/"></meta>
                    <meta name="twitter:card" content="summary_large_image"></meta>
                     {/* Google tag verification */}
                     <meta name="google-site-verification" content="S8YIhVckUSHSsN9H35PzFJdmxhtxOxY4WhI7zObUfx0" />
                </Helmet>
                    <div id="page-wrapper">
                        <Header {...this.props} />
                        {this.props.children}
                        <Footer {...this.props} />
                    </div>
            </React.Fragment>
        );
    }
}
